import { Model } from '..'
import Enhancer from '../Enhancer'

class Rate extends Model {
    constructor(json, ...args) {
        super(...args)
        this._model = json
        return new Proxy(this, Enhancer)
    }
    async rate(type) {
        this.apiBase = `rate/${type}/${this.id}`
        const payload = this.model
        delete payload.id
        this.reset()
        return await this.save('', payload)
    }

    async editRate() {
        this.apiBase = 'ratings'
        const result = await this.save()
        this.reset()
        return result
    }
}

export { Rate }
